'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userVouches = require('./user-vouches.html');

var _userVouches2 = _interopRequireDefault(_userVouches);

var _userVouches3 = require('./user-vouches.controller');

var _userVouches4 = _interopRequireDefault(_userVouches3);

require('./user-vouches.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userVouchesComponent = {
  restrict: 'E',
  bindings: {
    vouches: '<'
  },
  template: _userVouches2.default,
  controller: _userVouches4.default,
  controllerAs: 'vm'
};

exports.default = userVouchesComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-vouches/user-vouches.component.js
 **/